// Mock data for Andressa Urach Landing Page
// All content is configurable from this single file

export const siteConfig = {
  name: "ANDRESSA URACH",
  subtitle: "Conteúdo Exclusivo",
  description: "Plataforma oficial da Andressa Urach",
  warning: "O que você quer está aqui!",
  copyright: `© ${new Date().getFullYear()} Andressa Urach`,
  backgroundImage: "https://andressaurach.com.br/wp-content/uploads/2026/04/40-1-1920x1080.jpg",
};

export const primaryLinks = [
  {
    id: 2,
    label: "Fatal Fans",
    subtitle: "Acesso VIP e conteúdos especiais",
    url: "https://fatalfans.com/andressaurach",
    icon: "flame",
    isPrimary: true,
  },
];

export const socialLinks = [
  {
    id: 3,
    label: "Instagram",
    url: "https://www.instagram.com/aandressaurach/?hl=pt-br",
    icon: "instagram",
  },
  {
    id: 4,
    label: "X (Twitter)",
    url: "https://x.com/andressafurach?s=21",
    icon: "twitter",
  },
];
